import { Livewire, Alpine } from '../../vendor/livewire/livewire/dist/livewire.esm';

import flatpickr from 'flatpickr';

import.meta.glob([
    '../img/front/**',
]);

import './common/modal';
import './common/tooltip'
import './front/badge-scanner';
import './front/program'
import { init as initSW } from './common/utils/service-worker.js';
import initErrorLogger from './common/utils/js-error-logger.js';
import './front/carousels'

/*********************** Save JS errors to be accessible from mobile devices */

const logger = initErrorLogger({
    storageKey: "app:jsErrorLogs",
    maxEntries: 300,
    capture: { error: true, warn: true, log: false },
    exposeGlobal: true,
});

logger.attachTarget("#js-errors-stream", {
    replayExisting: true,
    insert: "prepend",
    limit: 300,
    formatter: (e) =>
        `${new Date(e.ts).toLocaleTimeString()} [${e.type}] ${e.message}`,
});

/*********************** Laravel associated JS librairies initilizations */

window.Alpine = window.Alpine || Alpine;

try {
    window.Livewire.start();
} catch (e) { };

/*********************** Service worker registration for offline mode */

initSW();

/*********************** UI initilizations */

/** Touchscreen */
if ('ontouchstart' in window || navigator.maxTouchPoints) {
    document.body.classList.add('is_touchscreen');
}

/**
 * Datepickers
 * Doc. : https://flatpickr.js.org/options/
 */

var current_lang = localStorage && localStorage.getItem('lang') && localStorage.getItem('lang').substring(0, 2);

flatpickr('.time-picker', {
    enableTime: true,
    noCalendar: true,
    dateFormat: current_lang === 'fr' ? 'H:i' : 'h:i K',
    time_24hr: current_lang === 'fr'
});

flatpickr('.date-picker-range', {
    mode: 'range',
    wrap: true,
    dateFormat: current_lang === 'fr' ? 'd-m-Y' : 'd-m-Y',
    locale: { rangeSeparator: '  —  ' }
});

